import { ViewController, VideoReloadEvent, TimeoutEvent, ChannelSwitchEvent } from "@gaming/srvg-classes-core";
import { VideoAreaView } from "../../View/VideoAreaView";
import { VideoViewController } from "./VideoViewController";
import { OverlayContainerContainerViewController } from "./OverlayContainerContainerViewController";

export class VideoAreaViewController extends ViewController {
    videoAreaView: VideoAreaView;

    videoController:VideoViewController;
    overlayContainerContainerViewController: OverlayContainerContainerViewController;

    constructor( options ) {
        options = options || {};
        options.view = options.videoAreaView;

        super( options );

        this.videoAreaView = options.videoAreaView || null;

        this.videoController = this.addChildViewController(new VideoViewController({
            videoView: this.videoAreaView.videoView,
            videoControlBar: this.videoAreaView.videoControlBar,
            channel: srvg.videooptions.defaultchannel || 0
        }));


        this.overlayContainerContainerViewController = this.addChildViewController( new OverlayContainerContainerViewController( { overlayContainerContainerView: this.videoAreaView.overlayContainerContainerView } ) );

        /******************* connect components ************************/

        app.timelineController.addSubscriberForEvent(this.videoController, VideoReloadEvent);

        if( app.inactivityController ) {
            app.inactivityController.addSubscriberForEvent(this.videoController, TimeoutEvent);
        }
        srvg.eventExchange.addEventHandler(this.videoController, 'all', ChannelSwitchEvent);

        /******************* start components ************************/
        this.videoController.play();
    }

    // hide all elements that would still be shown after other elements are already enabled
    handleTimeoutEvent(event: TimeoutEvent, provider){
        $('#statisticsButton').css('display','none');
        $('#rosterButton').css('display','none');
        $('#tableButton').css('display','none');
        $('#treeButton').css('display','none');

        $('#soundButton').css('display','none');
        $('#playpauseButton').css('display','none');
        $('#hdButton').css('display','none');

        $('#timelineOverlayContainerView').css('display','none');
        $('#manualOverlayContainerView').css('display','none');
    }
}